import React from "react";
import Hero from "./Hero";
// import WhyUs from "./Menu/About-Us/Speciality";
import Services from "./Services";
import Testimonials from "./Testimonials";
import CallToAction from "./CallToAction";
import Partners from "./Partners";
import About from "./About";

function Home() {

  return (
    <main className="landing-page">
      <div>
        <Hero />
        <Partners />
        <About />
        <Services />
        {/* <WhyUs /> */}
        <Testimonials />
        <CallToAction />
      </div>
    </main>
  );
}

export default Home;
